import { LocalAudioTrack } from 'twilio-video';
import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';
import { getBrowserInfo } from '../../utils';

export default function useLocalAudioToggle() {
  const { localTracks, getLocalAudioTrack } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  const { isEdge, isFirefox } = getBrowserInfo();

  const toggleAudioEnabled = useCallback(async () => {
    console.log('🎤 toggleAudioEnabled called', {
      hasAudioTrack: !!audioTrack,
      isEnabled,
      browser: isEdge ? 'Edge' : isFirefox ? 'Firefox' : 'Other',
    });

    if (audioTrack) {
      // Standard toggle for existing track
      if (isEdge || isFirefox) {
        // Edge/Firefox specific handling
        try {
          if (audioTrack.isEnabled) {
            audioTrack.disable();
          } else {
            audioTrack.enable();
          }
        } catch (error) {
          console.error('❌ Edge/Firefox audio toggle error:', error);
        }
      } else {
        // Standard behavior for other browsers
        audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
      }
    } else {
      // No audio track - try to create one (Edge specific issue)
      console.log('⚠️ No audio track found, attempting to create one');
      try {
        await getLocalAudioTrack();
        console.log('✅ Audio track created successfully');
      } catch (error) {
        console.error('❌ Failed to create audio track:', error);
      }
    }
  }, [audioTrack, isEnabled, getLocalAudioTrack, isEdge, isFirefox]);

  return [isEnabled, toggleAudioEnabled] as const;
}
